var map = {
	"./FoodDilevery.jpg": 7627,
	"./MoveTech.jpg": 656,
	"./NXProductivity.jpg": 9493,
	"./Vortyx-comm.png": 678,
	"./VortyxTech.jpg": 1807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4336;